type FormatNumberOption = {
  unitName?: string;
  withPlusSign?: boolean;
  noValueText?: string;
  numberOfDecimal?: number | undefined;
};
export const formatNumber = (
  value: number | null | undefined,
  option: FormatNumberOption
): string => {
  const opt = Object.assign(
    {
      unitName: '',
      withPlusSign: false,
      noValueText: '',
      numberOfDecimal: 0,
    },
    option
  );

  if (value === null || value === undefined) return opt.noValueText;

  const sign = opt.withPlusSign && value > 0 ? '+' : '';
  // return `${sign}${value.toLocaleString()}${opt.unitName}`;
  return `${sign}${floorString(value, opt.numberOfDecimal)}${opt.unitName}`;
};

export const floorString = (x: number, digits: number) => {
  const base = Math.pow(10, digits);
  const value = Math.floor(x * base) / base;

  const arr = value.toFixed(digits).split('.');
  let ret = Number(arr[0]).toLocaleString();
  if (arr.length === 2) ret = `${ret}.${arr[1]}`;

  return ret;
};

export const formatDateForString = (
  dateString: string | null | undefined,
  format: string
): string => {
  if (dateString === null || dateString === undefined || dateString === '')
    return '---';
  const date = new Date(dateString.replace(/-/g, '/'));

  let result = format;
  const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
  result = result.replace(/ddd/g, dayOfWeek[date.getDay()]);
  result = result.replace(/yyyy/g, date.getFullYear().toString());
  result = result.replace(
    /MM/g,
    ('0' + (date.getMonth() + 1).toString()).slice(-2)
  );
  result = result.replace(/M/g, (date.getMonth() + 1).toString());
  result = result.replace(/dd/g, ('0' + date.getDate().toString()).slice(-2));
  result = result.replace(/d/g, date.getDate().toString());
  result = result.replace(/HH/g, ('0' + date.getHours().toString()).slice(-2));
  result = result.replace(/H/g, date.getHours().toString());
  result = result.replace(
    /mm/g,
    ('0' + date.getMinutes().toString()).slice(-2)
  );
  result = result.replace(/m/g, date.getMinutes().toString());
  result = result.replace(
    /ss/g,
    ('0' + date.getSeconds().toString()).slice(-2)
  );
  result = result.replace(/s/g, date.getSeconds().toString());
  return result;
};

export const formatDate = (
  date: Date | null | undefined,
  format: string
): string => {
  if (date === null || date === undefined) return '---';

  let result = format;
  const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
  result = result.replace(/ddd/g, dayOfWeek[date.getDay()]);
  result = result.replace(/yyyy/g, date.getFullYear().toString());
  result = result.replace(
    /MM/g,
    ('0' + (date.getMonth() + 1).toString()).slice(-2)
  );
  result = result.replace(/M/g, (date.getMonth() + 1).toString());
  result = result.replace(/dd/g, ('0' + date.getDate().toString()).slice(-2));
  result = result.replace(/d/g, date.getDate().toString());
  result = result.replace(/HH/g, ('0' + date.getHours().toString()).slice(-2));
  result = result.replace(/H/g, date.getHours().toString());
  result = result.replace(
    /mm/g,
    ('0' + date.getMinutes().toString()).slice(-2)
  );
  result = result.replace(/m/g, date.getMinutes().toString());
  result = result.replace(
    /ss/g,
    ('0' + date.getSeconds().toString()).slice(-2)
  );
  result = result.replace(/s/g, date.getSeconds().toString());
  return result;
};
